import {
  Checkbox as MuiCheckbox,
  FormControlLabel as MuiFormControlLabel,
} from '@mui/material';
import Accordion from 'components/Accordion';
import { useTranslation } from 'react-i18next';

export const alertsList = [
  { value: 'hasActiveAlert', label: 'Has active alert' },
  { value: 'hasNoActiveAlerts', label: 'Has no alerts' },
];

export default function AlertsFilter({ setFilters, filters, defaultExpanded = false }) {
  const { t } = useTranslation();

  return (
    <Accordion title={t('Alerts')} defaultExpanded={defaultExpanded}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {alertsList.map((item) => {
          return (
            <MuiFormControlLabel
              key={item.value}
              control={
                <MuiCheckbox
                  checked={!!filters?.[item.value]}
                  onClick={() => {
                    setFilters((curr) => ({
                      ...curr,
                      [item.value]: !curr[item.value],
                    }));
                  }}
                />
              }
              label={t(item.label)}
            />
          );
        })}
      </div>
    </Accordion>
  );
}
